/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-ignore - material ui imports are unable to use .js file extensions
import { CheckIcon } from "@material-ui/icons/Check";
//@ts-ignore - material ui imports are unable to use .js file extensions
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
//@ts-ignore - material ui imports are unable to use .js file extensions
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import React, {
  useMemo,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { SlideInSelection } from "slideinselection";
import { IItemIdentifier } from "@wbmason/cart-service/interfaces/itemIdentifier.js";
import { ICartItemToAdd } from "@wbmason/cart-service/interfaces/cartItemToAdd.js";
import {
  ProductImage,
  ProductName,
  CartItemDropdownList,
  ViewCart,
  Checkout,
  SelectedToolTip,
  SuccessAlert,
  DivSafeZone,
} from "wbm-generic-components";
import { first } from "rxjs/operators";
import { WBMLoader } from "wbm-loader";
import { DigitalDataService } from "@wbmason/digital-data-service";
import {
  AddToCartMethod,
  AdobeEvent,
} from "@wbmason/digital-data-service/constants/enums.js";
import ConfigProps from "../constants/configProps.js";
import ProductCard from "./ProductCard.js";
//@ts-ignore - material ui imports are unable to use .js file extensions
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import { PurchaseProcess } from "../constants/enums.js";
import { ISlideInSelection } from "../interfaces/ISlideInSelection.js";
import {
  IIndicatorIcon,
  IIndicatorRequest,
} from "../interfaces/IIndicatorIcon.js";
import { ICheckoutProps } from "../interfaces/ICheckoutProps.js";
import { IPricedProduct } from "@wbmason/cart-service/interfaces/pricedProduct.js";
import { ICartItemTransaction } from "@wbmason/cart-service/interfaces/cartItemTransaction.js";
import { ICartItem } from "@wbmason/cart-service/interfaces/cartItem.js";
import {
  convertPricedProductToSearchResult,
  backFillFromCartItems,
  isYesOrTrue,
  createProductDetailsUrl,
  createProductCustomizeUrl,
} from "../utilities/utilities.js";
import { ProductService } from "../utilities/ProductService.js";
import { IProductImage } from "../interfaces/IProductImage.js";
import { IItemAvailability } from "../interfaces/IItemAvailability.js";
import { IRelatedProduct } from "@wbmason/cart-service/interfaces/relatedProduct.js";
import { CartService } from "@wbmason/cart-service";
import { IProductInfo } from "../interfaces/IProductInfo.js";
import { WBMUrlService } from "@wbmason/url-service";

const customTooltipElement = (
  <>
    <CheckIcon />
    <span>Added</span>
  </>
);

export interface IAddedToCartSlideoutProps {
  configProps: Record<string, string>;
  closeCallback?: () => void;
  appendRemoveContainerWidth: (isOpen: boolean) => void;
  lastAddedItem: ICartItem;
  optionalChildItems?: ICartItem[];
  header?: string;
  qtyMessage: string;
  cartItemTransactions?: ICartItemTransaction[];
  addToCartError?: string;
  checkoutProps: ICheckoutProps;
  lastAddedItemQty: number;
  addToCartMethod: () => void;
  addOnItem?: ICartItemToAdd[];
}

export const AddedToCartSlideout: React.FC<IAddedToCartSlideoutProps> = (
  props: IAddedToCartSlideoutProps,
) => {
  const [kitChildItems, setKitChildItems] = React.useState<ICartItem[]>([]);
  const [relatedProducts, setRelatedProducts] = React.useState<
    IPricedProduct[]
  >([]);
  const [relatedProductsLoading, setRelatedProductsLoading] = React.useState(
    false,
  );
  const [optionalChildLines, setOptionalChildLines] = React.useState<
    IRelatedProduct[]
  >([]);
  const [addedOptionalChildItem, setAddedOptionalChildItem] = useState<
    ICartItem
  >();
  const [optionalChildActionLoading, setOptionalChildActionLoading] = useState<
    boolean
  >(false);
  const [
    optionalChildLineTooltip,
    setOptionalChildLineTooltip,
  ] = React.useState(false);
  const [fullAdditionalItem, setFullAdditionalItem] = useState<ICartItem[]>([]);
  const [assemblyChargeItem, setAssemblyChargeItem] = useState<ICartItem>();
  const [childItemTotal, setChildItemTotal] = useState<number>(0);
  const [tooltipTimeoutId, setTooltipTimeoutId] = useState(0);
  const [displayToastError, setDisplayToastError] = useState<boolean>(false);
  const [optionalChildLineAdded, setOptionalChildLineAdded] = useState<boolean>(
    false,
  );
  const [optionalChildItemAction, setOptionalChildItemAction] = useState<
    string | undefined
  >();
  const [optionalChildLineRemoved, setOptionalChildLineRemoved] = useState<
    boolean
  >(false);
  const [itemIndicators, setItemIndicators] = useState<IIndicatorIcon[]>([]);
  const [indicatorsRequest, setIndicatorsRequest] = useState<
    IIndicatorRequest[]
  >([]);
  const [availability, setAvailability] = useState<IItemAvailability[]>([]);
  const [productIds, setProductIds] = useState<number[]>([]);
  const [productImages, setProductImages] = useState<IProductImage[]>([]);
  const [itemIdentifiers, setItemIdentifiers] = useState<IItemIdentifier[]>([]);
  const [productImagesLoaded, setProductImagesLoaded] = useState<boolean>(
    false,
  );
  const [cartItems, setCartItems] = useState<ICartItem[]>([]);
  const [addToCartItem, setAddToCartItem] = useState<ICartItem>();

  const [cartItemId, setCartItemId] = useState<string>("");
  const [addedCartItem, setAddedCartItem] = useState<ICartItem>();
  const SIS = useRef<ISlideInSelection>(null);
  const [lastAddedItemQty, setLastAddedItemQty] = useState<number>(
    props.lastAddedItemQty,
  );
  const [shoppingCartUrl, setShoppingCartUrl] = useState<string>("");
  const { addToCartMethod } = props;

  const optionalChildItem = useMemo(() => {
    return props.optionalChildItems?.filter(
      (item) =>
        item.itemIdentifier.id === props.lastAddedItem.itemIdentifier.id &&
        item.itemIdentifier.unitId ===
          props.lastAddedItem?.itemIdentifier.unitId,
    );
  }, [props.lastAddedItem, props.optionalChildItems]);

  const optionalChildItemState = useMemo(() => {
    return (
      optionalChildItemAction &&
      (props.lastAddedItem.id === optionalChildItemAction ||
        props.lastAddedItem.parentLineRecId.toString() ===
          optionalChildItemAction)
    );
  }, [props.lastAddedItem, optionalChildItemAction]);

  useEffect(() => {
    if (!optionalChildItemState) {
      setLastAddedItemQty(props.lastAddedItemQty);
    }
  }, [optionalChildItemState, props.lastAddedItemQty]);

  useEffect(() => {
    if (props.lastAddedItem && !optionalChildItemState) {
      setAddedCartItem(undefined);
      setRelatedProducts([]);
      setProductImagesLoaded(false);
      setCartItemId(props.lastAddedItem.id);
      if (
        !(
          props.lastAddedItem.id === optionalChildItemAction ||
          props.lastAddedItem.parentLineRecId.toString() ===
            optionalChildItemAction
        )
      ) {
        setOptionalChildItemAction(undefined);
      }
      if (
        isYesOrTrue(
          props.configProps[ConfigProps.DisplayAddToCartPromoItems],
        ) === true &&
        isYesOrTrue(
          props.configProps[ConfigProps.ActivateAdobeAddToCartPromoItems],
        ) === false
      ) {
        setRelatedProductsLoading(true);
        const subscription = ProductService.getFeaturedProducts(
          props.lastAddedItem.itemIdentifier,
        ).subscribe(
          (response: IPricedProduct[]) => {
            setRelatedProducts(response);
            const indicatorsObject = response.map((r) => ({
              id: r.itemId,
              unitId: r.unitId,
              couponOfferCode: r.couponOfferCode,
              priceCode: r.priceCode,
            }));
            setIndicatorsRequest(indicatorsObject);
            const ids = response.map((r) => parseInt(r.id));
            setProductIds(ids);
            const itemIdentifiers = response.map((r) => ({
              id: r.itemId,
              unitId: r.unitId,
              couponOfferCode: r.couponOfferCode,
            }));
            setItemIdentifiers(itemIdentifiers);
            setRelatedProductsLoading(false);
          },
          () => {
            console.error("Error fetching featured products");
            setRelatedProductsLoading(false);
          },
          () => {
            subscription.unsubscribe();
          },
        );
      }
    }
  }, [
    props.lastAddedItem,
    optionalChildItemState,
    optionalChildItemAction,
    props.configProps,
  ]);

  useEffect(() => {
    if (optionalChildItem && optionalChildItem.length > 0) {
      const subscription = ProductService.getOptionalChildProduct(
        optionalChildItem,
      ).subscribe((response) => {
        setOptionalChildLines(response);
      });
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [optionalChildItem]);

  useEffect(() => {
    if (indicatorsRequest.length > 0) {
      const subscription = ProductService.getIndicators(
        indicatorsRequest,
      ).subscribe((response) => {
        setItemIndicators(response);
      });
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [indicatorsRequest]);

  useEffect(() => {
    if (itemIdentifiers.length > 0) {
      const subscription = CartService.getAvailability(
        itemIdentifiers,
      ).subscribe((response) => {
        setAvailability(response);
      });
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [relatedProducts, itemIdentifiers]);

  useEffect(() => {
    if (productIds.length > 0) {
      const subscription = ProductService.getProductImages(
        productIds,
      ).subscribe((response) => {
        setProductImages(response);
        setProductImagesLoaded(true);
      });
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [productIds]);

  useEffect(() => {
    if (optionalChildLineRemoved && addedOptionalChildItem) {
      DigitalDataService.setProductInfo(
        [addedOptionalChildItem],
        false,
        AddToCartMethod.AddToCartSlideIn,
        false,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionalChildLineRemoved]);

  const getUpdatedCart = useCallback(() => {
    const childrenItems = props.cartItemTransactions?.filter(
      (potentialChild) =>
        potentialChild.cartItem.parentLineRecId ===
        props.lastAddedItem.cartLineRecId,
    );

    const cartSubscription = CartService.getCart().subscribe(
      (cartServicePayload) => {
        setCartItems(cartServicePayload.cart.items);
        if (!optionalChildItemState) {
          const { item, cartItem } = backFillFromCartItems(
            [props.lastAddedItem],
            cartServicePayload.cart.items,
          )[0];
          setAddToCartItem(item);
          setAddedCartItem(cartItem);
        }
        const addedItemRecId =
          props.lastAddedItem.parentLineRecId ||
          props.lastAddedItem.cartLineRecId;

        const newAssemblyChargeItem = cartServicePayload.cart.items.find(
          (cartItem) =>
            (cartItem.parentLineRecId || cartItem.cartLineRecId) ===
              addedItemRecId &&
            cartItem.purchaseProcess === PurchaseProcess.AssemblyCharge,
        );

        if (
          optionalChildItemAction &&
          newAssemblyChargeItem !== assemblyChargeItem
        ) {
          const item = optionalChildLineAdded
            ? newAssemblyChargeItem
            : assemblyChargeItem;

          setAddedOptionalChildItem(item);
        }
        setAssemblyChargeItem(newAssemblyChargeItem);

        if (childrenItems && childrenItems.length > 0) {
          const [fullItems, itemTotal] = cartServicePayload.cart.items.reduce(
            ([items, total], item) => {
              childrenItems.forEach((childItem: ICartItemTransaction) => {
                if (
                  item.itemIdentifier.id ===
                    childItem?.cartItem.itemIdentifier.id &&
                  item.itemIdentifier.unitId ===
                    childItem?.cartItem.itemIdentifier.unitId &&
                  item.parentLineRecId === childItem?.cartItem.parentLineRecId
                ) {
                  const deepCopyItem = {
                    ...item,
                    qty: props.lastAddedItemQty,
                  };
                  if (
                    deepCopyItem.purchaseProcess !==
                      PurchaseProcess.AssemblyCharge &&
                    !deepCopyItem.kitItemId
                  ) {
                    items.push(deepCopyItem);
                    total +=
                      deepCopyItem.sellPrice *
                      (props.lastAddedItem?.lastQtyAdded || 1);
                  }
                }
              });
              return [items, total];
            },
            [[], 0] as [ICartItem[], number],
          );
          setFullAdditionalItem(fullItems);
          setChildItemTotal(itemTotal);
        } else {
          setFullAdditionalItem([]);
        }

        const kitItems = cartServicePayload.cart.items.filter(
          (item) =>
            item.kitItemId === props.lastAddedItem.itemIdentifier.id &&
            item.kitItemUnitId === props.lastAddedItem.itemIdentifier.unitId,
        );
        setKitChildItems(kitItems);
      },
    );
    return () => {
      cartSubscription.unsubscribe();
    };
  }, [
    optionalChildItemState,
    optionalChildItemAction,
    props.cartItemTransactions,
    props.lastAddedItem,
    props.lastAddedItemQty,
    assemblyChargeItem,
    optionalChildLineAdded,
  ]);

  useEffect(() => {
    getUpdatedCart();
  }, [getUpdatedCart]);

  const cartItemDropdownProps = {
    alwaysFullWidth: true,
    displayVerticalLine: true,
    submittedKitQty: props.lastAddedItemQty,
    buttonContent: (
      <span>
        {props.lastAddedItem.itemIdentifier.id} will appear as the following
        items on your packing slip and invoice.
      </span>
    ),
    childrenItems: kitChildItems,
  };

  const additonalCartItemDropdownProps = {
    chevronLeft: true,
    alwaysFullWidth: true,
    displayVerticalLine: false,
    buttonContent: (
      <>
        <span className="additional-charges-label">Additional Charges</span>
        {
          <b className="additional-charges-total float-right">
            + ${childItemTotal.toFixed(2)}
          </b>
        }
      </>
    ),
    childrenItems: fullAdditionalItem,
  };

  const getAvailability = useMemo(() => {
    return (product: IProductInfo) => {
      return availability.filter(
        (q) =>
          q.itemId === product.itemIdentifier.id &&
          q.unitId === product.itemIdentifier.unitId,
      )[0];
    };
  }, [availability]);

  useEffect(() => {
    SIS?.current?.slideItIn();
    DigitalDataService.setCustomEvent(AdobeEvent.OpenAddedToCartSlider);
  }, [SIS]);

  const transformedRelatedProducts = useMemo(() => {
    if (relatedProducts.length && productImages.length) {
      relatedProducts.map((product) => {
        product.images = productImages.filter(
          (q) => q.ecItemRefRecID === parseInt(product.id),
        );
      });
    }
    return relatedProducts.map((related) =>
      convertPricedProductToSearchResult(related),
    );
  }, [relatedProducts, productImages]);

  useEffect(() => {
    if (
      (optionalChildLineAdded && assemblyChargeItem) ||
      (optionalChildLineRemoved && !assemblyChargeItem)
    ) {
      setOptionalChildActionLoading(false);
    }
  }, [optionalChildLineAdded, assemblyChargeItem, optionalChildLineRemoved]);

  const addOptionalChildItem = useCallback(
    (optionalChildItem: IPricedProduct, qty: number) => {
      setOptionalChildItemAction(cartItemId);
      setOptionalChildActionLoading(true);
      setOptionalChildLineRemoved(false);

      const itemToAdd: ICartItemToAdd[] = [
        {
          itemIdentifier: {
            id: optionalChildItem.itemId,
            unitId: optionalChildItem.unitId,
            couponOfferCode: optionalChildItem.couponOfferCode || "",
          },
          qty: Number(qty),
          notes: "",
          isPostSupercedeValidation: false,
          isSupercede: false,
          parentLineRecId: Number(cartItemId),
          itemPosition: 0,
          itemSellPrice: optionalChildItem.sellPrice,
        },
      ];
      CartService.addCartItems(itemToAdd, true).subscribe(() => {
        setOptionalChildLineAdded(true);
        setOptionalChildLineTooltip(true);
        addToCartMethod();
      });
    },
    [cartItemId, addToCartMethod],
  );

  const removeOptionalChildItem = (assemblyCharge: ICartItem) => {
    setOptionalChildItemAction(assemblyCharge.parentLineRecId.toString());
    setOptionalChildActionLoading(true);
    setOptionalChildLineAdded(false);
    setOptionalChildLineTooltip(false);

    CartService.removeCartItem(
      assemblyCharge.cartLineRecId.toString(),
    ).subscribe(() => {
      setOptionalChildLineRemoved(true);
    });
  };

  useEffect(() => {
    CartService.getCart()
      .pipe(first())
      .subscribe((cartServicePayload) => {
        const assmblyChargeItem = cartServicePayload.cart.items.find(
          (cartItem) =>
            cartItem.parentLineRecId === props.lastAddedItem.cartLineRecId,
        );
        if (
          !assmblyChargeItem &&
          props.addOnItem &&
          props.addOnItem.length &&
          optionalChildLines.length &&
          !optionalChildLineAdded
        ) {
          setOptionalChildLineAdded(true);

          addOptionalChildItem(
            optionalChildLines[0].relatedProducts[0],
            props.lastAddedItem.qty,
          );
        }
      });
  }, [
    props.addOnItem,
    optionalChildLines,
    props.lastAddedItem.qty,
    addOptionalChildItem,
    assemblyChargeItem,
    props.lastAddedItem.cartLineRecId,
    optionalChildLineAdded,
  ]);

  useEffect(() => {
    if (
      isYesOrTrue(
        props.configProps[ConfigProps.EnableResponsiveShoppingCart],
      ) &&
      props.checkoutProps.reactShoppingCart
    ) {
      setShoppingCartUrl(
        WBMUrlService.getShoppingCartUrl(
          props.checkoutProps.baseHostUrl ?? "",
          props.checkoutProps.reactShoppingCart,
        ),
      );
    } else {
      setShoppingCartUrl(
        `${props.checkoutProps.ECOM_BASE_URL}ShoppingCart.aspx`,
      );
    }
  }, [
    props.configProps,
    props.checkoutProps.baseHostUrl,
    props.checkoutProps.reactShoppingCart,
    props.checkoutProps.ECOM_BASE_URL,
  ]);

  const configProps = useMemo(() => {
    return {
      enableSinglePageCheckout: isYesOrTrue(
        props.configProps[ConfigProps.EnableSinglePageCheckout],
      ),
      usePunchout: isYesOrTrue(props.configProps[ConfigProps.UsePunchout]),
      enableResponsiveShoppingCart: isYesOrTrue(
        props.configProps[ConfigProps.EnableResponsiveShoppingCart],
      ),
    };
  }, [props.configProps]);

  const getProductDetailsUrl = (product: IProductInfo): string => {
    return createProductDetailsUrl(
      product,
      props.configProps,
      props.checkoutProps.ECOM_BASE_URL,
      props.checkoutProps.PDP_BASE_URL,
      typeof window !== "undefined" ? window.location.search : "",
    );
  };

  return (
    <div className="add-to-cart-slideout-container">
      <SlideInSelection
        ref={SIS}
        header="Added to Cart"
        containerId="body"
        closeCallback={props.closeCallback}
        appendRemoveContainerWidth={(isOpen: boolean) =>
          props.appendRemoveContainerWidth(isOpen)
        }
        backgroundColor={relatedProducts.length > 0 ? "" : "#FFFFFF"}
      >
        <div className="add-to-cart-container">
          {props.qtyMessage ? (
            <div className="label qty-message">
              <ErrorIcon className="mr-1" />
              <span>
                {props.qtyMessage.split(".")[0]}.
                <b>{props.qtyMessage.split(".")[1]}.</b>
              </span>
            </div>
          ) : (
            <div className="label">
              <span className="check bold-text">&#10003;</span>{" "}
              <span className="bold-text number"> {lastAddedItemQty} </span>{" "}
              Added to Cart
            </div>
          )}

          {addedCartItem ? (
            <div className="product-card-cart pb-4">
              <ProductImage
                className="cart-image"
                altText={addToCartItem?.brandImage?.itemId}
                height={72}
                width={72}
                imgUrl={
                  addToCartItem?.brandImage
                    ? `${addToCartItem?.brandImage.imagePathSmall}/${addToCartItem?.brandImage.imageFileNameSmall}`
                    : props.configProps[ConfigProps.NoImageAvailableImage]
                }
              />
              <div className="cart-content">
                <ProductName
                  brandName={addToCartItem?.brandName}
                  description={addToCartItem?.description}
                  itemIndicators={null}
                  displayId={
                    addToCartItem?.itemIdentifier.id +
                    (addToCartItem?.itemIdentifier.couponOfferCode || "")
                  }
                  productHREF={getProductDetailsUrl({
                    itemIdentifier: addToCartItem?.itemIdentifier,
                    brandName: addToCartItem?.brandName,
                    description: addToCartItem?.description,
                  } as IProductInfo)}
                  textBold
                  iconSize={18}
                />
              </div>
              {((optionalChildItem && optionalChildLines.length) ||
                optionalChildItemAction) &&
                isYesOrTrue(
                  props.configProps[ConfigProps.EnableOptionalChildLines],
                ) && (
                  <>
                    <div
                      className={`extra-item row mt-0 ${
                        optionalChildActionLoading
                          ? ""
                          : assemblyChargeItem && !optionalChildLineTooltip
                          ? "qty-text"
                          : optionalChildLineTooltip && assemblyChargeItem
                          ? "remove"
                          : "add"
                      }`}
                    >
                      <div
                        className={`col-auto ${
                          optionalChildLineAdded && !optionalChildActionLoading
                            ? "w-text"
                            : ""
                        } pl-1 pr-0`}
                      >
                        <b>
                          {
                            optionalChildLines[0].relatedProducts[0].text[0]
                              .text
                          }{" "}
                          for $
                          {optionalChildLines[0].relatedProducts[0].sellPrice?.toFixed(
                            2,
                          )}
                        </b>
                        {assemblyChargeItem &&
                          !optionalChildLineTooltip &&
                          !optionalChildActionLoading && (
                            <p className="qty-updated mt-0">
                              {
                                optionalChildLines[0].relatedProducts[0].text[0]
                                  .text
                              }{" "}
                              Qty has been updated!
                            </p>
                          )}
                      </div>

                      <div className="col-auto pl-0 pr-1 ml-auto">
                        {optionalChildActionLoading && <WBMLoader />}

                        {!assemblyChargeItem && !optionalChildActionLoading && (
                          <span
                            className="add-item"
                            onClick={() =>
                              addOptionalChildItem(
                                optionalChildLines[0].relatedProducts[0],
                                props.lastAddedItem.qty,
                              )
                            }
                          >
                            <AddShoppingCartIcon /> add
                          </span>
                        )}
                        {assemblyChargeItem && optionalChildLineTooltip && (
                          <SelectedToolTip
                            arrow
                            open={false}
                            placement="top"
                            title={customTooltipElement}
                          >
                            <span
                              className="remove-item"
                              onClick={() =>
                                removeOptionalChildItem(assemblyChargeItem!)
                              }
                            >
                              <DeleteOutlineIcon />
                              Remove
                            </span>
                          </SelectedToolTip>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {displayToastError && (
                <SuccessAlert
                  timerLengthInMS={3500}
                  danger
                  dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
                  dangerAttentionText="An error has occurred!"
                  onClickClose={() => setDisplayToastError(false)}
                  attentionText={""}
                  text={""}
                />
              )}
              <div className="mr-3">
                <SelectedToolTip
                  arrow
                  placement="top"
                  open={tooltipTimeoutId > 0}
                  title={customTooltipElement}
                >
                  <span className=""></span>
                </SelectedToolTip>
              </div>
              {props.lastAddedItem?.purchaseProcess == PurchaseProcess.Kit && (
                <div className="w-100 mx-4">
                  <CartItemDropdownList {...cartItemDropdownProps} />
                </div>
              )}
              {fullAdditionalItem.length > 0 &&
                props.lastAddedItem?.purchaseProcess !==
                  PurchaseProcess.Kit && (
                  <div className="w-100 mx-4">
                    <CartItemDropdownList {...additonalCartItemDropdownProps} />
                  </div>
                )}
              <div className="spacing" />
            </div>
          ) : (
            <div className="d-flex py-3 px-4 bg-white">
              <div className="skeleton product-img"></div>
              <div className="ml-4">
                <div className="skeleton mb-2 product-desc"></div>
                <div className="product-item skeleton"></div>
              </div>
            </div>
          )}
          {isYesOrTrue(
            props.configProps[ConfigProps.DisplayAddToCartPromoItems],
          ) === true &&
            isYesOrTrue(
              props.configProps[ConfigProps.ActivateAdobeAddToCartPromoItems],
            ) === true &&
            isYesOrTrue(
              props.configProps[ConfigProps.ActivateAdobeTargetDIVTagSafeZones],
            ) === true && (
              <DivSafeZone
                id="add-to-cart-recommendations"
                className="dsz-shop"
                configProps={props.configProps}
              />
            )}
          {relatedProducts.length > 0 && (
            <div className="secondary-label bold-text">
              Consider These Other Products
            </div>
          )}
          <div
            className={`slide-in-container cart-items-container position-initial${
              relatedProducts.length > 0 ? "" : " no-related-products"
            }`}
          >
            {relatedProductsLoading && <WBMLoader />}
            {transformedRelatedProducts.length > 0 &&
              transformedRelatedProducts.map((relatedProduct, i) => {
                return (
                  <div key={"product" + i} className="product-cards">
                    <ProductCard
                      configProps={props.configProps}
                      productInfo={relatedProduct}
                      itemIndicators={itemIndicators}
                      itemAvailability={
                        relatedProduct.preventPurchase
                          ? undefined
                          : getAvailability(relatedProduct)
                      }
                      maxLength={
                        Number(
                          props.configProps[ConfigProps.QuantityMaxDigits],
                        ) || 4
                      }
                      cartItems={cartItems}
                      productImagesLoaded={productImagesLoaded}
                      displayAddToCart
                      addToCartMethod={AddToCartMethod.AddToCartSlideIn}
                      hideRelevanceScore
                      closeCallback={props.closeCallback}
                      productDetailsUrl={getProductDetailsUrl(relatedProduct)}
                      productCustomizeUrl={createProductCustomizeUrl(
                        relatedProduct,
                        props.checkoutProps.ECOM_BASE_URL,
                      )}
                      addFeaturedProduct={() => {
                        setOptionalChildItemAction(undefined);
                        addToCartMethod();
                      }}
                      hostUrl={props.checkoutProps.ECOM_BASE_URL}
                    />
                  </div>
                );
              })}
          </div>
          <div className="select-done">
            <div className="row">
              <div className="col-4 pr-0">
                <ViewCart viewCartUrl={shoppingCartUrl} />
              </div>
              <div className="col-8 no-padding-right">
                <Checkout
                  configProps={configProps}
                  hasItemAgreements={props.checkoutProps.hasItemAgreements}
                  checkoutAppUri={props.checkoutProps.checkoutAppUri}
                  isLoggedIn={props.checkoutProps.isLoggedIn}
                  loginUrl={props.checkoutProps.loginUrl}
                  ecomBaseUrl={props.checkoutProps.ECOM_BASE_URL}
                  shoppingCartUrl={shoppingCartUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </SlideInSelection>
    </div>
  );
};

export default AddedToCartSlideout;
